<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CywJAB/tc-custom/9781626565784.jpg?1708779380453" alt="This image is the cover for the book When Money Talks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Money Talks
      </h1>
      <p class="bookDescription body article font2">
        <b>“When money talks, democracy walks. Read this book to learn how We the People can take back our elections from the billionaires.” —Robert B. Reich, former U.S. Secretary of Labor and author of <i>The System: Who Rigged It, How We Fix It</i></b><br/>  <br/> Special-interest money is destroying our democratic process. And ever since the Citizens United decision threw out campaign spending limits abridgments of free speech, Americans want to know what they can do about it. Derek Cressman gives us the tools, both intellectual and tactical, to fight back.<br/>  <br/> There’s nothing inherently unconstitutional in limiting the amount of speech, Cressman insists. We do it all the time—for example, cities control when and where demonstrations can take place or how long people can speak at council meetings. Moreover, he argues that while you choose to patronize Fox News, MSNBC, the <i>New York Times</i>, or the <i>Wall Street Journal</i>, political advertising is forced upon you. It’s not really free speech at all—it’s paid speech. It’s not at all what the Founders had in mind when they wrote the First Amendment.<br/>  <br/> Cressman examines how courts have foiled attempts to limit campaign spending, details what a constitutional amendment limiting paid speech should say, and reveals an overlooked political tool that concerned citizens can use to help gain the amendment’s passage. Seven times before in our history we have approved constitutional amendments to overturn wrongheaded rulings by the Supreme Court—and there’s no reason we can’t do it again.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Derek Cressman, Thom Hartmann, Miles Rapoport
      </h2>
      
      <p class="authorDescription body article">Derek Cressman has worked professionally to strengthen campaign finance laws since 1995 as director of U.S. PIRG’s Democracy Program and a national vice president with Common Cause. He ran for California secretary of state in June 2014. www.derekcressman.com.</P><br/><br/><P>Thom Hartmann is a nationally and internationally syndicated talkshow host whose radio and TV shows are available in over a billion homes nationwide. He is the author of 24 books, most recently the bestselling The Crash of 2016.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a86e8c98